import './App.css';
import Home from './Components/Home/Home';
import Navbar from './Components/Navbar/Navbar'
import About from './Components/About/About'
import Experience from './Components/Experience/Experience'
import Testimonial from './Components/Testimonials/Testimonial'
import Contact from './Components/Contact/Contact'
import Footer from './Components/Footer/Footer'




function App() {
  return (
    <div className="App">
      <Home/>
      <Navbar/>
      <About/>
      <Experience/>
      <Testimonial/>
      <Contact/>
      <Footer/>
    </div>
  );
}

export default App;

 